import { InvoiceType } from "../constants/finance-constants";

export interface CreditNote {
  customerId:  string,
  amount?: number,
  description: string,
  invoiceId: string,
  creditNoteDate: Date,
  chargeId?: string,
  creditType: CreditType
}

export enum CreditType {
  WAIVER='WAIVER',
  INVOICE_CANCEL='INVOICE_CANCEL'
}
